import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { APICallService } from 'src/app/services/api-call.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { SecurityService } from 'src/app/services/security.service';
import { AppMessageService } from 'src/app/services/app-message.service';
import { UserDetailsService } from 'src/app/services/user-details.service';

@Component({
    selector: 'payt-opt-lov',
    templateUrl: './payt-opt-lov.component.html',
    styleUrls: ['./payt-opt-lov.component.css']
})
export class PaymentOptionsLovComponent implements OnInit {

    private selectedData: any;

    public tableSelected: any;

    public titleLov: string = "PAYMENT OPTIONS";

    moduleId: string = 'BMM064';
    
    public paytCds: any = [];

    paytOptTable: any = {
        cols: [
            {
                key: "PAYT_CD_PADDED",
                header: "Payment Code",
                dataType: "string",
                width: '40%'
            },
            {
                key: "PAYT_DESC",
                header: "Payment Description",
                dataType: "string",
                width: '60%'
            }
        ],
        tblData: [],
        selection: "single",
        paginator: true,
        rowsPerPage: 10,
        lazy: false,
        totalRecords: 15,
        loading: false,
    };

    constructor(
        private dialogRef: MatDialogRef<PaymentOptionsLovComponent>,
        private _api: APICallService,
        private securityService: SecurityService,
        private jsonDataService: JsonDataService,
        private appMessageService: AppMessageService,
        private userDetailService: UserDetailsService,
        @Inject(MAT_DIALOG_DATA) public fromMainData: any,
    ) { }

    ngOnInit(): void {
        try {
            this.tableSelected = this.paytOptTable;
            this.getPaytOptData();
        } catch (e) {
    console.error(e);
            
        }
    }

    onRowClick(ev: any) {
        try {
            this.selectedData = ev;
        } catch (e) {
    console.error(e);
            
        }
    }

    getPaytOptData() {
        try {
            this.paytOptTable.loading = true;
            this.jsonDataService.contorlLoading(true);
            this.paytCds = [];

            for (const payt of this.fromMainData.rows) {
                this.paytCds.push(payt.PAYT_CD);
            }

            this._api.getPaytOpt({
                moduleId: this.fromMainData.moduleId,
                userId: this.userDetailService.userId,
                type: "LOV"
            }).subscribe({
                next: (response: any) => {
                    this.securityService.checkRequestKeyResponse(response, () => {
                        this.securityService.hasValidCsrfToken(response, () => {
                            let paytOpt = JSON.parse(this.jsonDataService.decrypt(response.response));
                            if (paytOpt.moduleId === this.moduleId) {
                                this.jsonDataService.contorlLoading(false);
                                this.tableSelected.tblData = paytOpt.data.filter((d: any)=> !this.paytCds.includes(d.PAYT_CD) && d.ACTIVE_TAG === "A");
                                this.paytOptTable.loading = false;
                            } else {
                                this.paytOptTable.loading = false;
                                this.jsonDataService.contorlLoading(false);
                                this.appMessageService.showAppMessage("You do not have the correct privilege to access the data. Kindly contact your administrator for assistance.", "error");
                            }
                        });        
                    });
                }, error: (e: any) => {
                    this.paytOptTable.loading = false;
                    this.jsonDataService.contorlLoading(false);
                    this.appMessageService.showAppMessage(e, "error");
                }
            });
        } catch (e) {
    console.error(e);
            this.paytOptTable.loading = false;
            this.jsonDataService.contorlLoading(false);
        }
    }

    onClose(str: string) {
        try {
            if (this.selectedData == '' || this.selectedData == null) {
                this.dialogRef.close({ content: '', button: str });
            } else {
                this.dialogRef.close({ content: this.selectedData, button: str });
            }
        } catch (e) {
    console.error(e);
            
        }
    }
}
